import { Button, Collapse, message } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { generatePath, redirect, useFetcher, useNavigate } from 'react-router-dom';
import { makeContact } from '../../api/contact/contact';
import { Contact } from '../../components/form';
import { Page } from '../../components/page';
import { ValidationError } from '../../library/classes/exceptions';
import { CancelButton } from '../../ui';
const { Panel } = Collapse

//import Customer from 'components/form/customer/customer.jsx'

const ContactCreate = ({ title }) => {
	const fetcher = useFetcher()
	const navigate = useNavigate();
	// const [isLoading, setIsLoading] = useState(true)
	// const navigate = useNavigate()
	// useEffect(() => {
	// 	setIsLoading(true)
	// 	getContact(contactId)
	// 		.then(({ data }) => {
	// 			setCustomerContactDetails(data)
	// 			setIsLoading(false)
	// 		})
	// 		.finally(() => {
	// 			setIsLoading(false)
	// 		})
	// }, [])


	const handleCustomerDetailContactsSubmit = (values) => {
		fetcher.submit({
			...values,
			action: 'contactCreate'
		}, {
			method: 'post',
			encType: 'application/json'
		})
	}

	return (
		<Page className='customers-detail' title={title}>
			{
				<Collapse defaultActiveKey={['1']}>
					<Panel header={<><img src="/icons/headericons/contacts.svg" style={{ width: '1.25rem', verticalAlign: 'sub', marginRight: '8px' }} />Contact Details</>} key="1" >
						<Contact errors={fetcher.data?.errors} onFinish={handleCustomerDetailContactsSubmit}>
							<div style={{ display: 'flex', gap: '8px' }}>
								<Button type="primary" htmlType="submit" style={{ width: 100 }}>Save</Button>
								<CancelButton onClick={() => navigate(-1)} style={{ width: 100 }}>Cancel</CancelButton>
							</div>
						</Contact>
					</Panel>
				</Collapse>
			}
		</Page>
	)
}

ContactCreate.propTypes = {
	title: PropTypes.string
}

ContactCreate.Actions = {
	contactCreate: async ({ data }) => {
		try {
			const { message: msg, data: d } = await makeContact(data)
			message.success(msg)
			return redirect(generatePath('/customers/contacts/:id', {
				id: d.id //maybe to some other route
			}))
			//	return trueF
		}
		catch (error) {
			message.error(error.message)

			if (error instanceof ValidationError) {
				const formattedErrors = {
				}
				Object.entries(error.errors).forEach(([k, v]) => {
					formattedErrors[k] = v
				})

				return {
					errors: formattedErrors
				}

			}



		}
		return false
	},
}

export default ContactCreate
